import { render, staticRenderFns } from "./StandardPanel.vue?vue&type=template&id=0b92c448&scoped=true&"
import script from "./StandardPanel.vue?vue&type=script&lang=js&"
export * from "./StandardPanel.vue?vue&type=script&lang=js&"
import style0 from "./StandardPanel.vue?vue&type=style&index=0&id=0b92c448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b92c448",
  null
  
)

export default component.exports